import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { OpenFileLink } from '../../../common/components/data-display';
import { selectToken } from '../../../features/auth/ducks';
import { connect } from 'react-redux';

import Spin from 'antd/lib/spin';
import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../../common/components/data-display';

const Column = Table.Column;
const mapStateToProps = state => ({
    token: selectToken(state)
});


const SMSTemplatesMap = {
    contract_activation: "Aktivácia zmluvy",
    loan_activation: "Aktivácia pôžičky",
    instructions_sent: "Odoslanie emailu s inštrukciami",
    user_not_found: "Používateľ neexistuje",
    unpaid_installment: "Upomienka 1",
    unpaid_installment2: "Upomienka 2",
    unpaid_installment3: "Upomienka 3"
}

@translate()
@connect(mapStateToProps)
export default class SmsDashboard extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        data: PropTypes.object
    };

    render() {
        const {
            data,
            t,
            token
        } = this.props;

        const smsLogs = data && data.smsLogs ? Object.entries(data.smsLogs).map(smsTemplate => {
            return {
                template: smsTemplate[0],
                today: smsTemplate[1].today,
                yesterday: smsTemplate[1].yesterday,
                thisMonth: smsTemplate[1].thisMonth,
                lastMonth: smsTemplate[1].lastMonth,
            }
        }).sort((a, b) => (a.thisMonth.count < b.thisMonth.count) ? 1 : ((b.thisMonth.count < a.thisMonth.count) ? -1 : 0)) : [];
        return (
            <div>
                {!data ?
                    <Spin className="dasboard-spinner" spinning={!data}>
                        <div className="dashboard-spinner-message">{t("Prebieha výpočet dát pre dashboard")}</div>
                    </Spin> :
                    <div>
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "35%" }} ></td>
                                    <td style={{ textAlign: "center" }} >{t("Zaslané")}</td>
                                </tr>
                            </tbody>
                        </table >
                        <ResponsiveTable
                            dataSource={smsLogs}
                            pagination={false}
                            rowClassName={(record) => record.style ? `section-row-${record.style}` : ``}>
                            <Column
                                title={t('Názov SMS')}
                                // className='dashboard-col-5'
                                dataIndex="template"
                                key="template"
                                render={value => t(SMSTemplatesMap[value])}
                            />
                            <Column
                                title={t('Dnes')}
                                // className='dashboard-col-5'
                                dataIndex="today"
                                key="today"
                                render={value => value.count}
                            />
                            <Column
                                title={t('Včera')}
                                // className='dashboard-col-5'
                                dataIndex="yesterday"
                                key="yesterday"
                                render={value => value.count}

                            />
                            <Column
                                title={t('Tento mesiac')}
                                // className='dashboard-col-5'
                                dataIndex="thisMonth"
                                key="thisMonth"
                                render={value => value.count}

                            />
                            <Column
                                title={t('Minulý mesiac')}
                                // className='dashboard-col-5'
                                dataIndex="lastMonth"
                                key="lastMonth"
                                render={value => value.count}

                            />
                        </ResponsiveTable>
                    </div>
                }
                {token && <table>
                    <tbody>
                        <tr>
                            <td>Export prehľadu zaslaných SMS správ za posledných 30 dní:   </td>
                            <td></td>
                            <td>
                                <OpenFileLink
                                    isButton
                                    href={`${process.env.REACT_APP_API_URL}/messaging/report/sms?token=${token}`}
                                >
                                    {t('Export')}
                                </OpenFileLink>
                            </td>
                        </tr>
                    </tbody>
                </table>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/SmsDashboard.js